export default __webpack_public_path__ + "static/media/30266d698308f504e1831a7e98977580.svg";